import React, { useState, useEffect } from "react";
import TauriBreadCrumbDropdown from "../TauriBreadcrumbDropdown";

const TauriConfigTypeCodeDropdown = ({ ConfigCode, handleSelected }) => {

    let configTypeCode = [];

    configTypeCode = ConfigCode?.split(',') || [];

    const storedConfig = localStorage.getItem('selectedConfig');
    const initialConfigTypeCode = storedConfig || (configTypeCode.length > 0 ? configTypeCode[0]?.trim() : '');

    const [selectedConfigTypeCode, setSelectedConfigTypeCode] = useState(initialConfigTypeCode);

    const handleSelection = (configtype) => {
        setSelectedConfigTypeCode(configtype);
        handleSelected(configtype);
    }

    useEffect(() => {
        handleSelected(selectedConfigTypeCode);
    }, []);

    const items = configTypeCode.map((config) => ({
        label: config?.trim(),
        value: config?.trim(),
    }));

    return (
        <TauriBreadCrumbDropdown
            items={items}
            onSelect={handleSelection}
            selectedItem={selectedConfigTypeCode}
            className="mr-3"
            id="configtypeDropdown"
            placeholder="--Select ConfigType--"
        />
    )
}

export default TauriConfigTypeCodeDropdown